import * as React from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { ISPImage } from '../ISPImage';
import { ICarouselProps } from './ICarouselProps';
import {
  Image,
  IImageProps,
  ImageFit
} from 'office-ui-fabric-react';

export interface ICarouselState {
  imgs: ISPImage[];
  listId: string;
  lastId: string;
}

export default class Carousel extends React.Component<ICarouselProps, ICarouselState> {

  constructor(props) {
    debugger;    
    super(props);
    this.state = {
      imgs: this.props.images,
      listId: this.props.listId,
      lastId: ''
    };
  }

  public render() {
    debugger;
    const images = this._setupImages();
    return (
      <div>
        <ImageGallery
          items={images}
          slideInterval={this.props.scrollSpeed * 5000}
          showBullets={this.props.showBulletButtons}
          showThumbnails={this.props.showThumpnails}
          renderItem={this._renderItem}
        />
      </div>
    );
  }


  public componentWillReceiveProps(nextProps: ICarouselProps) {
    this.state.lastId = this.state.listId;
    this.state.listId = nextProps.listId;
  }


  private _setupImages() {
    const items = this.state.imgs.map((item, i) => (
      {
        original: this.state.imgs[i].src,
        thumbnail: this.state.imgs[i].src,
        description: this.state.imgs[i].description,
        url: this.state.imgs[i].url
      }
    ));
    return items;
  }

  private _renderItem(item) {
    return (
      <div className='image-gallery-image'>
        <a href={item.url}>
          <img
            src={item.original}
            alt={item.originalAlt}
            srcSet={item.srcSet}
            sizes={item.sizes}
          />
        </a>
        {
          item.description &&
          <span className='image-gallery-description'>
            {item.description}
          </span>
        }
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ../../../../../src/webparts/bannerWp/components/Carousel/Carousel.tsx